import { useMutation, useQueryClient } from "@tanstack/react-query";

import { applyProposal } from "./api";
import type { ApplyProposalOptions, Proposal } from "./api";

// Применение предложения. `prompt_tweak` →
// override промпта (без опций); `role_change` → override модели (с
// выбранной человеком `model`); `config_update` → override org-config-ключа
// (с выбранными `configKey` + `configValue`). На успех инвалидируем список
// — статус сменился на applied, кнопки исчезнут. Ошибку (409 не pending /
// 422 нет/невалидны параметры) пробрасываем наверх для тоста. Инвалидация
// по смысловому префиксу матчит запись любого org-скоупа (см.
// `src/query/scope.ts`).
interface ApplyProposalArgs extends ApplyProposalOptions {
  readonly id: string;
}

export function useApplyProposal(): ReturnType<
  typeof useMutation<Proposal, Error, ApplyProposalArgs>
> {
  const queryClient = useQueryClient();
  return useMutation<Proposal, Error, ApplyProposalArgs>({
    mutationFn: ({ id, ...opts }) => applyProposal(id, opts),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ["self-improvement", "proposals"],
      });
    },
  });
}
